<template>
    <div>
<!--        <h1 class="mb-8 text-3xl font-bold">-->
<!--            <Link class="text-indigo-400 hover:text-indigo-600" :href="this.route('tickets')">{{ __('Tickets') }}</Link>-->
<!--            <span class="font-medium text-indigo-400">/</span> {{ __('Create') }}-->
<!--        </h1>-->
        <div class="max-w-full overflow-hidden bg-white rounded-md shadow">
            <form @submit.prevent="store">
                <div class="flex flex-wrap p-8 -mb-8 -mr-6">


                    <select-input-filter placeholder="Start typing" :onInput="doFilter" :items="customers"
                                         v-if="user_access.ticket.update && auth.user.role.slug !== 'student'"
                                         v-model="form.user_id" :error="form.errors.user_id"
                                         class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Customer')">
                    </select-input-filter>


                    <select-input v-model="form.priority_id" :error="form.errors.priority_id" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Priority')">
                        <option :value="null" />
                        <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>
                    <select-input v-if="!(hidden_fields && hidden_fields.includes('department'))" v-model="form.department_id" :error="form.errors.department_id" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Department')" :required="true">
                        <option :value="null" />
                        <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>

                    <select-input-filter placeholder="Start typing" :onInput="doFilterUsersExceptCustomer" :items="usersExceptCustomers"
                                         v-if="auth.user.role.slug !== 'student' && user_access.ticket.update && !(hidden_fields && hidden_fields.includes('assigned_to'))"
                                         v-model="form.assigned_to" :error="form.errors.assigned_to"
                                         class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Assigned to')">
                    </select-input-filter>

                    <select-input v-model="form.campus" :error="form.errors.campus" class="w-full pb-8 pr-6 lg:w-1/3"
                    :label="__('Campus')">




                    <option value="bnuuxbridge">BNU Uxbridge</option>
                    <option value="bnu-high-wycombe">BNU High Wycombe</option>
                    <option value="bnu-nottingham">BNU Nottingham</option>
                    <option value="online">Online</option>
                </select-input>
                    <!-- <select-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))" v-model="form.type_id" :error="form.errors.type_id" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Ticket Type')" :required="true">
                        <option :value="null" />
                        <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>
                    <select-input v-if="!(hidden_fields && hidden_fields.includes('category'))" v-model="form.category_id" :error="form.errors.category_id" class="w-full pb-8 pr-6 lg:w-1/3" :label="__('Category')" :required="true">
                        <option :value="null" />
                        <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input> -->
                    <text-input v-model="form.subject" :error="form.errors.subject" class="w-full pb-8 pr-6 lg:w-full" :label="__('Subject')" />
                    <div class="w-full pb-8 pr-6">
                        <label class="form-label" >Request Details:</label>
                        <ckeditor id="ticketDetails" :editor="editor" v-model="form.details" :config="editorConfig"></ckeditor>
                    </div>
                    <input ref="file" type="file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip" class="hidden" multiple="multiple" @change="fileInputChange" />
                    <div class="flex-col w-full pb-8 pr-6 lg:w-full">
                        <button type="button" class="flex items-center justify-center btn" @click="fileBrowse">
                            <icon name="file" class="flex-shrink-0 h-8 pr-1 fill-gray-400" /> <h4>{{ __('Attach files') }}</h4>
                        </button>
                        <div v-if="form.files.length" class="flex items-center justify-between w-full pt-8 pr-6 lg:w-1/2" v-for="(file, fi) in form.files" :key="fi">
                            <div class="flex-1 pr-1">
                                {{ file.name }} <span class="text-xs text-gray-500">({{ getFileSize(file.size) }})</span>
                            </div>
                            <button type="button" class="flex items-center justify-center btn" @click="fileRemove(file, fi)">
                                {{ __('Remove') }}</button>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }}
                        {{ __('Ticket') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/Shared/UploadAdapter';

export default {
    metaInfo: { title: 'Create Ticket' },
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        TextareaInput,
        Link,
        Icon,
    },
    watch: {
        'form.user_id'(newValue) {
            // alert(newValue);
      const selectedCustomer = this.customers.find(customer => customer.id === newValue);
            console.log(selectedCustomer.campus);
            this.form.campus = selectedCustomer.campus;
    //   if (selectedCustomer && selectedCustomer.role.slug === 'student') {
    //     this.handleStudentSelected();
    //   }
    }
    },
    layout: Layout,
    props: {
        customers: Array,
        usersExceptCustomers: Array,
        priorities: Array,
        statuses: Array,
        types: Array,
        departments: Array,
        categories: Array,
        auth: Object,
        hidden_fields: Object,
    },
    remember: false,
    data() {
        return {
            user_access: this.$page.props.auth.user.access,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|', 'undo', 'redo' ],
                table: {
                    toolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                },
                extraPlugins: [this.uploader],
            },
            form: this.$inertia.form({
                user_id: null,
                priority_id: null,
                status_id: null,
                department_id: null,
                category_id: null,
                assigned_to: null,
                type_id: null,
                subject: null,
                details: '',
                campus:null,
                files: [],
            }),
        }
    },
    created() {
       
        this.setDefaultValue(this.statuses, 'status_id', 'Pending')
        this.setDefaultValue(this.priorities, 'priority_id', 'Generally')
        this.setDefaultValue(this.departments, 'department_id', 'Technical')
    },
    methods: {
        uploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
        doFilter(e){
            this.axios.get(this.route('filter.customers', {search: e.target.value})).then((res)=>{
                this.customers.splice(0, this.customers.length, ...res.data);
                
            })
        },
        doFilterUsersExceptCustomer(e){
            this.axios.get(this.route('filter.users_except_customer', {search: e.target.value})).then((res)=>{
                this.usersExceptCustomers.splice(0, this.usersExceptCustomers.length, ...res.data);
            })
        },
        setDefaultValue(arr, key, value){
            const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
            if(find){
                this.form[key] = find['id']
            }
        },
        fileInputChange(e) {
            let selectedFiles = e.target.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i]);
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1);
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        store() {
            this.form.user_id = this.auth.user.id;
            this.form.post(this.route('tickets.store'))
        },
    },
}
</script>
